export function getUtcTimestampSeconds() {
	const now = new Date
	const utcTimestamp = Date.UTC( now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds() )
	const utcTimestampSeconds = Math.round( utcTimestamp / 1000 )

	return utcTimestampSeconds
}

export function getDateAsYYYYMmDd( dateObject = false ) {
	let d = dateObject ? dateObject : new Date(),
		month = '' + ( d.getMonth() + 1 ),
		day = '' + d.getDate(),
		year = d.getFullYear()

	if ( month.length < 2 ) {
		month = '0' + month
	}

	if ( day.length < 2 ) {
		day = '0' + day
	}

	return [ year, month, day ].join( '-' )
}
